// extracted by mini-css-extract-plugin
export var card = "index-module--card--mKDBk";
export var cardContent = "index-module--cardContent--1_jCA";
export var name = "index-module--name--3XqI8";
export var description = "index-module--description--2Hhqt";
export var pictureContainer = "index-module--pictureContainer--3wdHr";
export var picture = "index-module--picture--2QYgR";
export var handles = "index-module--handles--1h4FD";